import axios from "axios";
import apiClient from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";
import { setAuthToken, setUserData } from "../utils/index";

export const requestOTPAPI = async (email, password) => {
    try {
        const response = await axios.post(ATP_API_URL.LOGIN, {
            email,
            password
        });

        if (response?.status === 200 || response?.data) {
            // if (response.data?.token) {
            //     sessionStorage.setItem('tempAuthToken', response.data.token);
            // }
            return {
                success: true,
                message: response.data?.message || "OTP sent to your email",
                data: response.data,
            };
        } else {
            return {
                success: false,
                message: "Failed to send OTP. Please try again.",
                data: null
            };
        }
    } catch (error) {
        console.error("Request OTP Error:", error);
        return {
            success: false,
            message: error.response?.data?.detail || error.response?.data?.message || "Failed to send OTP. Please check your credentials.",
            data: null
        };
    }
};

export const verifyOTPAPI = async (email, otp) => {
    try {
        const payload = {
            email,
            otp: otp
        };

        // const token = sessionStorage.getItem('tempAuthToken');
        // console.log("TOEKN : ", token);
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        // if (token) {
        //     config.headers['Authorization'] = `Bearer ${token}`;
        // }

        const response = await apiClient.post(ATP_API_URL.VERIFY_OTP, payload, config);

        if (response?.status === 200 && response.data?.success) {
            sessionStorage.removeItem('tempAuthToken');

            if (response.data?.accessToken) {
                setAuthToken(response.data.accessToken);
            }

            const userData = {
                email: response.data.email || email,
                userName: response.data.userName,
                refreshToken: response.data.refreshToken
            };
            setUserData(userData);

            return {
                success: true,
                message: response.data.message || "OTP verified successfully",
                data: response.data,
                token: response.data?.accessToken,
                user: userData
            };
        } else {
            return {
                success: false,
                message: "Invalid OTP. Please check and try again.",
                data: null
            };
        }
    } catch (error) {
        console.error("Verify OTP Error:", error);

        let errorMessage = "Invalid OTP. Please try again.";

        if (error.response?.data?.errors) {
            const errors = error.response.data.errors;
            const errorMessages = Object.keys(errors).map(key => {
                return `${key}: ${errors[key].join(', ')}`;
            });
            errorMessage = errorMessages.join('; ');
        } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (error.response?.data?.title) {
            errorMessage = error.response.data.title;
        }

        return {
            success: false,
            message: errorMessage,
            data: null
        };
    }
}

/**
 * Legacy function for backward compatibility
 * @deprecated Use requestOTPAPI instead
 */
export const loginWithCredentialsAPI = async (email, password) => {
    return requestOTPAPI(email, password);
};
